import { useState } from "react";
import { MdExpandLess, MdExpandMore, MdLanguage } from "react-icons/md";
import {
    Container,
    Content,
    Header,
    LegendColor,
    LegendInfo,
    LegendItem,
    LegendLabel,
    LegendStatsDetail,
    Title,
    ToggleButton,
} from "./styles";
import useMapData from "ui/pages/app/planejamentoOperacional/hooks/useMapData";
import useRelatorioContext from "ui/pages/app/planejamentoOperacional/hooks/useRelatorioContext";


type Props = {
    legendaAderencia: {
        semPlanejamento: {talhoes: number, somaTalhoes: string},
        aderente: {talhoes: number, somaTalhoes: string},
        naoAderente: {talhoes: number, somaTalhoes: string},
    }
};

export function LegendaRelatorioAderencia({ legendaAderencia }: Props) {
    const [collapsed, setCollapsed] = useState(false);
    const { semPlanejamento, aderente, naoAderente} = legendaAderencia;
    const { sidebarMenuOpen } = useMapData();
    const { showLegendsRelatorio } = useRelatorioContext();

    const LEGEND_ITEMS = [
        {
            variant: "green" as const,
            label: "Aderente",
            stats: `${aderente.talhoes} • ${aderente.somaTalhoes} ha`,
        },
        {
            variant: "red" as const,
            label: "Não Aderente",
            stats: `${naoAderente.talhoes} • ${naoAderente.somaTalhoes} ha`,
        },
        {
            variant: "neutral" as const,
            label: "Sem Planejamento",
            stats: `${semPlanejamento.talhoes} • ${semPlanejamento.somaTalhoes} ha`,
        },
    ];

    function toggleLegend() {
        setCollapsed((prev) => !prev);
    }

    if (!showLegendsRelatorio) return null;

    return (
        <Container $minimized={collapsed} $isOpenMenu={sidebarMenuOpen}>
            <Header>
                <Title>
                    <MdLanguage />
                    Legenda
                </Title>
                <ToggleButton type="button" onClick={toggleLegend} aria-label="Alternar legenda">
                    {collapsed ? <MdExpandLess /> : <MdExpandMore />}
                </ToggleButton>
            </Header>

            <Content $collapsed={collapsed}>
                {LEGEND_ITEMS.map((item) => (
                    <LegendItem key={item.label}>
                        <LegendColor $variant={item.variant} />
                        <LegendInfo>
                            <LegendLabel>{item.label}</LegendLabel>
                            <LegendStatsDetail>{item.stats}</LegendStatsDetail>
                        </LegendInfo>
                    </LegendItem>
                ))}
            </Content>
        </Container>
    );
}
